import { render } from "./CardCustom.vue?vue&type=template&id=7fac2770&scoped=true"
import script from "./CardCustom.vue?vue&type=script&lang=js"
export * from "./CardCustom.vue?vue&type=script&lang=js"

import "./CardCustom.vue?vue&type=style&index=0&id=7fac2770&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fac2770"]])

export default __exports__